import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {Auth0Provider} from "@auth0/auth0-react";
import {auth0_audience, auth0_client_id, auth0_domain} from "./app.config";
import AppProvider from "./context/AppProvider";
import {SystemAlertProvider} from "./context/SystemAlertContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Custom redirect callback for Auth0
const onRedirectCallback = (appState) => {

    // Handle organization signup intent
    if (appState?.intent === 'create_organization') {

        // Store plan data in sessionStorage
        if (appState.planData) {
            sessionStorage.setItem('organizationPlanData', JSON.stringify(appState.planData));
        }

        // Store redirect flag for MainPage to handle
        const redirectTarget = appState.returnTo || '/signup/organization';
        sessionStorage.setItem('auth0RedirectTo', redirectTarget);

        // Stay on /home - MainPage will handle React Router navigation
        // Auth0 needs us to navigate somewhere, so we use window.history to stay on current path
        // This prevents Auth0 from using its default redirect behavior
        window.history.replaceState({}, document.title, window.location.pathname);
        return;
    }

    // Handle invitation acceptance intent
    if (appState?.intent === 'accept_invitation') {

        // Store redirect flag for MainPage to handle
        const redirectTarget = appState.returnTo;
        sessionStorage.setItem('auth0RedirectTo', redirectTarget);

        // Stay on /home - MainPage will handle React Router navigation
        window.history.replaceState({}, document.title, window.location.pathname);
        return;
    }

    // Default behavior: for other cases, store returnTo if provided
    if (appState?.returnTo) {
        sessionStorage.setItem('auth0RedirectTo', appState.returnTo);
        // Stay on current path, let MainPage handle navigation
        window.history.replaceState({}, document.title, window.location.pathname);
    }
};

root.render(
    <Auth0Provider
        domain={auth0_domain}
        clientId={auth0_client_id}
        authorizationParams={{
            audience: `${auth0_audience}`,
            redirect_uri: `${window.location.origin}/home`,
            scope: "openid profile email offline_access"
        }}
        onRedirectCallback={onRedirectCallback}
        cacheLocation="localstorage"
        logoutParams={{
            returnTo: window.location.origin,
        }}

    >
        <AppProvider>
            <SystemAlertProvider>
                <App/>
            </SystemAlertProvider>
        </AppProvider>
    </Auth0Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
